module.exports = __webpack_public_path__ + "static/scale-model-of-kinetic-steam-works-in-oakland-california-c76fe7e0fa9148a70d43d0009ed4f6fd.png";